import { render, staticRenderFns } from "./cocal-import.vue?vue&type=template&id=419ae40e&"
import script from "./cocal-import.vue?vue&type=script&lang=js&"
export * from "./cocal-import.vue?vue&type=script&lang=js&"
import style0 from "./cocal-import.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports